import { SpinnerIcon } from 'shared/icons/SpinnerIcon';
import type { Filters, ResultItem as ResultItemType } from '@/domain';
import type { LoginId } from '@/types/common';
import { FetchFailedMessage } from '../FetchFailedMessage';
import { PaginationWrapper } from '../pagination/PaginationWrapper';
import { ResultItem } from '../resultItem/ResultItem';

type ResultListMapProps = {
    stats: Record<string, unknown>;
    filters: Filters;
    onFilterChanged: (filters: Filters) => void;
    numberOfPreloadedImages: number;
    results: ResultItemType[] | false | null;
    loginId?: LoginId;
    loading?: boolean;
    error?: Error;
};

export const ResultListMap = ({
    results,
    filters,
    numberOfPreloadedImages,
    loginId,
    stats,
    onFilterChanged,
    loading = false,
    error,
}: ResultListMapProps) => {
    if (loading) {
        return (
            <div className="p-64 flex flex-col items-center w-full" data-testid="loadingSpinner">
                <SpinnerIcon size={24} />
            </div>
        );
    }

    if (error || results === null || results === false) {
        return <FetchFailedMessage />;
    }

    if (results.length === 0) {
        return (
            <p className="p-16 text-22 font-bold text-center" data-testid="emptyResultList">
                Ingen treff akkurat nå. Zoom ut i kartet for å få flere treff.
            </p>
        );
    }

    return (
        <section className="grid grid-cols-2 gap-8 p-16" id="ads" data-testid="resultList">
            <h1 className="sr-only">Søkeresultater</h1>
            {results.map((ad, index) => (
                <ResultItem
                    key={ad.id}
                    rank={index}
                    ad={ad}
                    filters={filters}
                    loading={index < numberOfPreloadedImages ? 'eager' : 'lazy'}
                    loginId={loginId}
                />
            ))}
            <div className="col-span-2 flex justify-center">
                <PaginationWrapper stats={stats} onFilterChanged={onFilterChanged} />
            </div>
        </section>
    );
};
